<template>
  <b-row class="py-2">
    <b-col>
      <b-row>
        <b-col>
          <b-badge class="bg-blue">
            <i class="fa fa-file mr-2"></i>
            Re-registration
          </b-badge>
        </b-col>
      </b-row>

      <b-row>
        <b-col>
          <b-card class="my-1">
            <b-row v-if="data.RE_REGISTRATION_FORM_2" class="mt-3">
              <b-col>
                <table class="min-w-full leading-normal mt-1 text-gray border border-gray">
                  <thead>
                  <tr class="bg-gray-pale">
                    <td colspan="12" class="px-2 py-2 font-bold">Form 2</td>
                  </tr>
                  </thead>
                  <tbody>
                    <tr class="border-b border-gray-pale">
                      <td class="px-2 py-1 text-capitalize font-bold">Company Name</td>
                      <td class="px-2 py-1">
                        <span>{{ data.RE_REGISTRATION_FORM_2.data.companyName }}</span>
                      </td>
                    </tr>
                    <tr class="border-b border-gray-pale">
                      <td class="px-2 py-1 text-capitalize font-bold">Registration Number</td>
                      <td class="px-2 py-1">
                        <span>{{ data.RE_REGISTRATION_FORM_2.data.brn }}</span>
                      </td>
                    </tr>
                    <tr class="border-b border-gray-pale">
                      <td class="px-2 py-1 text-capitalize font-bold">Current Company Category</td>
                      <td class="px-2 py-1">
                        <span>{{ cleanEntityType(data.RE_REGISTRATION_FORM_2.data.oldSubType)  }}</span>
                      </td>
                    </tr>
                    <tr class="border-b border-gray-pale">
                      <td class="px-2 py-1 text-capitalize font-bold">New Company Category</td>
                      <td class="px-2 py-1">
                        <span>{{ cleanEntityType(data.RE_REGISTRATION_FORM_2.data.newSubType) }}</span>
                      </td>
                    </tr>
                  </tbody>
                </table>
                <table class="min-w-full leading-normal text-gray border border-gray">
                  <thead>
                  <tr class="bg-gray-pale">
                    <td colspan="12" class="px-2 py-2 font-bold">Statement Of Compliance (SIGNATORY)</td>
                  </tr>
                  </thead>
                  <tbody>
                  <tr>
                    <td colspan="12">
                      <LegalPersons :persons="[data.RE_REGISTRATION_FORM_2.data.signatory]" />
                    </td>
                  </tr>
                  </tbody>
                </table>
              </b-col>
            </b-row>

            <b-row v-if="data.FORM_6" class="mt-3">
              <b-col>
                <table class="min-w-full leading-normal mt-1 text-gray border border-gray">
                  <thead>
                  <tr class="bg-gray-pale">
                    <td colspan="12" class="px-2 py-2 font-bold">Form 6</td>
                  </tr>
                  </thead>
                  <tbody>
                  <tr class="border-b border-gray-pale">
                    <td class="px-2 py-1 text-capitalize font-bold">Company Name</td>
                    <td class="px-2 py-1">
                      <span>{{ data.FORM_6.data.companyName }}</span>
                    </td>
                  </tr>
                  <tr class="border-b border-gray-pale">
                    <td class="px-2 py-1 text-capitalize font-bold">Registration Number</td>
                    <td class="px-2 py-1">
                      <span>{{ data.FORM_6.data.brn }}</span>
                    </td>
                  </tr>
                  <tr class="border-b border-gray-pale">
                    <td class="px-2 py-1 text-capitalize font-bold">Current Company Category</td>
                    <td class="px-2 py-1">
                      <span>{{ cleanEntityType(data.FORM_6.data.oldSubType)  }}</span>
                    </td>
                  </tr>
                  <tr class="border-b border-gray-pale">
                    <td class="px-2 py-1 text-capitalize font-bold">New Company Category</td>
                    <td class="px-2 py-1">
                      <span>{{ cleanEntityType(data.FORM_6.data.newSubType) }}</span>
                    </td>
                  </tr>
                  </tbody>
                </table>
                <table class="min-w-full leading-normal text-gray border border-gray">
                  <thead>
                  <tr class="bg-gray-pale">
                    <td colspan="12" class="px-2 py-2 font-bold">Statement Of Compliance (SIGNATORY)</td>
                  </tr>
                  </thead>
                  <tbody>
                  <tr>
                    <td colspan="12">
                      <LegalPersons :persons="[data.FORM_6.data.signatory]" />
                    </td>
                  </tr>
                  </tbody>
                </table>
              </b-col>
            </b-row>

            <b-row v-if="data.FORM_3" class="mt-3">
              <b-col>
                <table class="min-w-full leading-normal mt-1 text-gray border border-gray">
                  <thead>
                  <tr class="bg-gray-pale">
                    <td colspan="12" class="px-2 py-2 font-bold">Form 3</td>
                  </tr>
                  </thead>
                  <tbody>
                  <tr class="border-b border-gray-pale">
                    <td class="px-2 py-1 text-capitalize font-bold">Registration Number</td>
                    <td class="px-2 py-1">
                      <span>{{ data.FORM_3.data.brn }}</span>
                    </td>
                  </tr>
                  </tbody>
                </table>
                <table class="min-w-full leading-normal text-gray border border-gray">
                  <thead>
                  <tr class="bg-gray-pale">
                    <td colspan="12" class="px-2 py-2 font-bold">Declaration of Compliance (SIGNATORY)</td>
                  </tr>
                  </thead>
                  <tbody>
                  <tr>
                    <td colspan="12">
                      <LegalPersons :persons="[data.FORM_3.data.declarant]" />
                    </td>
                  </tr>
                  </tbody>
                </table>
              </b-col>
            </b-row>

            <b-row v-if="data.CHANGE_OF_DIRECTORS" class="mt-3">
              <b-col>
                <table class="min-w-full leading-normal mt-1 text-gray border border-gray">
                  <thead>
                  <tr class="bg-gray-pale">
                    <td colspan="12" class="px-2 py-2 font-bold">Form 20</td>
                  </tr>
                  </thead>
                  <tbody>
                  <tr class="border-b border-gray-pale">
                    <td class="px-2 py-1 text-capitalize font-bold">Effective Date Of Appointment</td>
                    <td class="px-2 py-1">
                      <span>{{ dateFormat(data.CHANGE_OF_DIRECTORS.data.effectiveDateOfAppointment) }}</span>
                    </td>
                  </tr>
                  </tbody>
                </table>
                <table class="min-w-full leading-normal text-gray border border-gray">
                  <thead>
                  <tr class="bg-gray-pale">
                    <td colspan="12" class="px-2 py-2 font-bold">Appointment of Directors</td>
                  </tr>
                  </thead>
                  <tbody>
                  <tr>
                    <td colspan="12">
                      <LegalPersons :persons="data.CHANGE_OF_DIRECTORS.data.currentForm20.directors" />
                    </td>
                  </tr>
                  </tbody>
                </table>
              </b-col>
            </b-row>

            <b-row v-if="data.FORM_19" class="mt-3">
              <b-col>
                <table class="min-w-full leading-normal mt-1 text-gray border border-gray">
                  <thead>
                  <tr class="bg-gray-pale">
                    <td colspan="12" class="px-2 py-2 font-bold">Form 19</td>
                  </tr>
                  </thead>
                  <tbody>
                  <tr class="border-b border-gray-pale">
                    <td class="px-2 py-1 text-capitalize">Date Of Consent To Appointment</td>
                    <td class="px-2 py-1">
                      <span>{{ dateFormat(data.FORM_19.data.dateOfConsentToAppointment) }}</span>
                    </td>
                  </tr>
                  </tbody>
                </table>
                <table class="min-w-full leading-normal text-gray border border-gray">
                  <thead>
                  <tr class="bg-gray-pale">
                    <td colspan="12" class="px-2 py-2 font-bold">Appointment of Directors</td>
                  </tr>
                  </thead>
                  <tbody>
                  <tr>
                    <td colspan="12">
                      <LegalPersons :persons="data.FORM_19.data.directors" />
                    </td>
                  </tr>
                  </tbody>
                </table>
              </b-col>
            </b-row>

            <!-- RE_REGISTRATION_FORM_8 -->
            <b-row v-if="data.RE_REGISTRATION_FORM_8 && data.RE_REGISTRATION_FORM_8.data" class="mt-3">
              <b-col>
                <table class="min-w-full leading-normal mt-1 text-gray border border-gray">
                  <thead>
                  <tr class="bg-gray-pale">
                    <td colspan="12" class="px-2 py-2 font-bold">Form 8</td>
                  </tr>
                  </thead>
                  <tbody>
                  <tr class="border-b border-gray-pale">
                    <td class="px-2 py-1 text-capitalize font-bold">Proposed Name</td>
                    <td class="px-2 py-1">
                      <span>{{ data.RE_REGISTRATION_FORM_8.data.proposedName }}</span>
                    </td>
                  </tr>
                  <tr class="border-b border-gray-pale">
                    <td class="px-2 py-1 text-capitalize font-bold">Company Name</td>
                    <td class="px-2 py-1">
                      <span>{{ data.RE_REGISTRATION_FORM_8.data.companyName }}</span>
                    </td>
                  </tr>
                  <tr class="border-b border-gray-pale">
                    <td class="px-2 py-1 text-capitalize font-bold">Proposed Extension</td>
                    <td class="px-2 py-1">
                      <span>{{ data.RE_REGISTRATION_FORM_8.data.proposedExtension }}</span>
                    </td>
                  </tr>
                  <tr class="border-b border-gray-pale">
                    <td class="px-2 py-1 text-capitalize font-bold">Registration Number</td>
                    <td class="px-2 py-1">
                      <span>{{ data.RE_REGISTRATION_FORM_8.data.brn }}</span>
                    </td>
                  </tr>
                  </tbody>
                </table>
                <table class="min-w-full leading-normal text-gray border border-gray">
                  <thead>
                  <tr class="bg-gray-pale">
                    <td colspan="12" class="px-2 py-2 font-bold">Declarant</td>
                  </tr>
                  </thead>
                  <tbody>
                  <tr>
                    <td colspan="12">
                      <LegalPersons :persons="[data.RE_REGISTRATION_FORM_8.data.declarant]" />
                    </td>
                  </tr>
                  </tbody>
                </table>
              </b-col>
            </b-row>

            <!-- RE_REGISTRATION_SHAREHOLDERS -->
            <b-row v-if="data.RE_REGISTRATION_SHAREHOLDERS && data.RE_REGISTRATION_SHAREHOLDERS.data" class="mt-3">
              <b-col>
                <table class="min-w-full leading-normal mt-1 text-gray border border-gray">
                  <thead>
                  <tr class="bg-gray-pale">
                    <td colspan="12" class="px-2 py-2 font-bold">Shareholders</td>
                  </tr>
                  </thead>
                  <tbody>
                  <tr>
                    <td colspan="12">
                      <LegalPersons :persons="data.RE_REGISTRATION_SHAREHOLDERS.data.shareholders" />
                    </td>
                  </tr>
                  </tbody>
                </table>
              </b-col>
            </b-row>

            <!-- RE_REGISTRATION_SHARE_STRUCTURE -->
            <b-row v-if="data.RE_REGISTRATION_SHARE_STRUCTURE && data.RE_REGISTRATION_SHARE_STRUCTURE.data" class="mt-3">
              <b-col>
                <table class="min-w-full leading-normal mt-1 text-gray border border-gray">
                  <thead>
                  <tr class="bg-gray-pale">
                    <td colspan="12" class="px-2 py-2 font-bold">Share Structure</td>
                  </tr>
                  </thead>
                  <tbody>
                  <tr class="border-b border-gray-pale">
                    <td class="px-2 py-1 text-capitalize font-bold">New Nominal Share Capital</td>
                    <td class="px-2 py-1">
                      <span>{{ data.RE_REGISTRATION_SHARE_STRUCTURE.data.newNominalShareCapital.toLocaleString() }} {{ data.RE_REGISTRATION_SHARE_STRUCTURE.data.currency }}</span>
                    </td>
                  </tr>
                  <tr class="border-b border-gray-pale" v-if="data.RE_REGISTRATION_SHARE_STRUCTURE.data.oldNominalShareCapital">
                    <td class="px-2 py-1 text-capitalize font-bold">Old Nominal Share Capital</td>
                    <td class="px-2 py-1">
                      <span>{{ data.RE_REGISTRATION_SHARE_STRUCTURE.data.oldNominalShareCapital.toLocaleString() }} {{ data.RE_REGISTRATION_SHARE_STRUCTURE.data.currency }}</span>
                    </td>
                  </tr>
                  <tr class="border-b border-gray-pale">
                    <td class="px-2 py-1 text-capitalize font-bold">New Nominal Number Of Shares</td>
                    <td class="px-2 py-1">
                      <span>{{ data.RE_REGISTRATION_SHARE_STRUCTURE.data.newNominalNumberOfShares.toLocaleString() }}</span>
                    </td>
                  </tr>
                  </tbody>
                </table>
                <table class="min-w-full leading-normal text-gray border border-gray">
                  <thead>
                  <tr class="bg-gray-pale">
                    <td colspan="12" class="px-2 py-2 font-bold">New Nominal Share Classifications</td>
                  </tr>
                  <tr>
                    <th class="px-2 py-1 text-capitalize">Nominal Class</th>
                    <th class="px-2 py-1 text-center text-capitalize">Number</th>
                    <th class="px-2 py-1 text-center text-capitalize">Value</th>
                    <th class="px-2 py-1 text-center text-capitalize">Total Nominal Value</th>
                  </tr>
                  </thead>
                  <tbody>
                  <tr style="border: solid 1px #dedede;" v-for="(classification, idx) in data.RE_REGISTRATION_SHARE_STRUCTURE.data.newNominalShareClassifications" :key="idx">
                    <td class="px-2 py-1 text-capitalize font-bold">
                      <span v-if="classification.nominalClass !== 'OTHER'">{{ classification.nominalClass }}</span>
                      <span v-else>{{ classification.otherClassName }}</span>
                    </td>
                    <td class="px-2 py-1 text-center">
                      <span>{{ classification.number.toLocaleString() }}</span>
                    </td>
                    <td class="px-2 py-1 text-center">
                      <span>{{ classification.value.toLocaleString() }}</span>
                    </td>
                    <td class="px-2 py-1 text-center">
                      <span>{{ classification.totalNominalValue.toLocaleString() }}</span>
                    </td>
                  </tr>
                  </tbody>
                </table>
              </b-col>
            </b-row>

            <!-- RE_REGISTRATION_SHAREHOLDING -->
            <b-row v-if="data.RE_REGISTRATION_SHAREHOLDING && data.RE_REGISTRATION_SHAREHOLDING.data" class="mt-3">
              <b-col>
                <table class="min-w-full leading-normal mt-1 text-gray border border-gray">
                  <thead>
                  <tr class="bg-gray-pale">
                    <td colspan="12" class="px-2 py-2 font-bold">Shareholding</td>
                  </tr>
                  </thead>
                  <tbody>
                  <tr class="border-b border-gray-pale">
                    <td class="px-2 py-1 text-capitalize font-bold">Total Shares Allotted</td>
                    <td class="px-2 py-1">
                      <span>{{ data.RE_REGISTRATION_SHAREHOLDING.data.totalSharesAllotted.toLocaleString() }}</span>
                    </td>
                  </tr>
                  <tr class="border-b border-gray-pale">
                    <td class="px-2 py-1 text-capitalize font-bold">Total Value Of Shares Allotted</td>
                    <td class="px-2 py-1">
                      <span>{{ data.RE_REGISTRATION_SHAREHOLDING.data.totalValueOfSharesAllotted.toLocaleString() }}</span>
                    </td>
                  </tr>
                  </tbody>
                </table>
                <table class="min-w-full leading-normal text-gray border border-gray">
                  <thead>
                  <tr class="bg-gray-pale">
                    <td colspan="12" class="px-2 py-2 font-bold">Allotments</td>
                  </tr>
                  </thead>
                </table>
                <table class="min-w-full leading-normal text-gray"
                       style="border: solid 1px #dedede;"
                       v-for="(allotment, idx) in data.RE_REGISTRATION_SHAREHOLDING.data.allotments"
                       :key="idx">
                  <thead>
                  <tr class="bg-gray-pale">
                    <th class="px-2 py-1 text-uppercase">Name</th>
                    <th class="px-2 py-1 text-center text-uppercase">Share Class</th>
                    <th class="px-2 py-1 text-center text-uppercase">Number of Shares</th>
                    <th class="px-2 py-1 text-center text-uppercase">Amount Paid</th>
                  </tr>
                  </thead>
                  <thead>
                  <tr>
                    <td class="px-2 py-1 font-bold text-blue text-uppercase" colspan="12">
                      <span>{{ allotment.name }}</span>
                      <b-badge class="bg-blue mx-2">{{ allotment.entityType }}</b-badge>
                    </td>
                  </tr>
                  </thead>
                  <tbody style="border: solid 1px #dedede;" v-for="(share, idx2) in allotment.shares" :key="idx2">
                  <tr>
                    <td class="px-2 py-1"></td>
                    <td class="px-2 py-1 text-uppercase font-bold">
                      <span v-if="share.nominalClass !== 'OTHER'">{{ share.nominalClass }}</span>
                      <span v-else>{{ share.otherClassName }}</span>
                    </td>
                    <td class="px-2 py-1 text-center">
                      <span v-if="!share.subClasses || share.subClasses.length === 0">
                        {{ share.numberOfShares.toLocaleString() }}
                      </span>
                    </td>
                    <td class="px-2 py-1 text-center">
                      <span v-if="!share.subClasses || share.subClasses.length === 0">
                        {{ share.amountPaid.toLocaleString() }}
                      </span>
                    </td>
                  </tr>
                  <tr v-for="(subClass, idx3) in (share.subClasses || [])" :key="idx3">
                    <td class="px-2 py-1"></td>
                    <td class="px-2 py-1 text-capitalize">
                      <span>Class {{ subClass.nominalClass }}</span>
                    </td>
                    <td class="px-2 py-1 text-center">
                      <span>{{ subClass.numberOfShares.toLocaleString() }}</span>
                    </td>
                    <td class="px-2 py-1 text-center">
                      <span>{{ subClass.amountPaid.toLocaleString() }}</span>
                    </td>
                  </tr>
                  </tbody>
                </table>
              </b-col>
            </b-row>

            <!-- MEMARTS -->
            <b-row v-if="data.MEMARTS && data.MEMARTS.data" class="mt-3">
              <b-col>
                <table class="min-w-full leading-normal mt-1 text-gray border border-gray">
                  <thead>
                  <tr class="bg-gray-pale">
                    <td colspan="12" class="px-2 py-2 font-bold">MemArts</td>
                  </tr>
                  </thead>
                  <tbody>
                  <tr class="border-b border-gray-pale">
                    <td class="px-2 py-1 text-capitalize" colspan="12">
                      <b-form-textarea class="w-full" rows="4" :value="data.MEMARTS.data.descriptionOfChanges"
                                       disabled></b-form-textarea>
                    </td>
                  </tr>
                  <tr class="border-b border-gray-pale">
                    <td class="px-2 py-1 text-capitalize font-bold">Alters Memorandum Of Association</td>
                    <td class="px-2 py-1">
                      <span>{{ data.MEMARTS.data.altersMemorandumOfAssociation }}</span>
                    </td>
                  </tr>
                  <tr class="border-b border-gray-pale">
                    <td class="px-2 py-1 text-capitalize font-bold">Alters Articles Of Association</td>
                    <td class="px-2 py-1">
                      <span>{{ data.MEMARTS.data.altersArticlesOfAssociation }}</span>
                    </td>
                  </tr>
                  <tr class="border-b border-gray-pale" v-if="data.MEMARTS.data.newSubType">
                    <td class="px-2 py-1 text-capitalize font-bold">New Sub Type</td>
                    <td class="px-2 py-1">
                      <span>{{ cleanEntityType(data.MEMARTS.data.newSubType) }}</span>
                    </td>
                  </tr>
                  </tbody>
                </table>
                <table class="min-w-full leading-normal text-gray border border-gray" v-if="data.MEMARTS.data.objectives && data.MEMARTS.data.objectives.length > 0">
                  <thead>
                  <tr class="bg-gray-pale">
                    <td colspan="12" class="px-2 py-2 font-bold">Objectives</td>
                  </tr>
                  </thead>
                  <tbody>
                  <tr style="border: solid 1px #dedede;" v-for="(item, idx) in data.MEMARTS.data.objectives" :key="idx">
                    <td class="px-2 py-1 text-capitalize">
                      <b-form-textarea disabled :value="item.objective" class="text-xs" rows="4"></b-form-textarea>
                    </td>
                  </tr>
                  </tbody>
                </table>
                <table class="min-w-full leading-normal text-gray border border-gray" v-if="data.MEMARTS.data.currentMembers && data.MEMARTS.data.currentMembers.length > 0">
                  <thead>
                  <tr class="bg-gray-pale">
                    <td colspan="12" class="px-2 py-2 font-bold">Current Members</td>
                  </tr>
                  </thead>
                  <tbody>
                  <tr>
                    <td colspan="12">
                      <LegalPersons :persons="data.MEMARTS.data.currentMembers" />
                    </td>
                  </tr>
                  </tbody>
                </table>
              </b-col>
            </b-row>
          </b-card>
        </b-col>
      </b-row>

    </b-col>
  </b-row>
</template>

<script>
import LegalPersons from "@/views/home/commons/LegalPersons.vue";
import moment from "moment";

export default {
  name: "CompanyReregistration",
  components: { LegalPersons},
  props: {
    data: Object,
    brn: String,
    type: String
  },
  methods: {
    dateFormat(date) {
      if (!date) return "N/A";
      return moment(date).format("DD-MM-YYYY");
    },
    cleanEntityType(name) {
      if (!name) return "N/A";
      let n = name.replaceAll("-", " ");
      return n.charAt(0).toUpperCase() + n.slice(1);
    }
  }
};
</script>

<style scoped>
th, td{
  font-size: 12px;
}
</style>